import React, { useState, useEffect } from 'react';
import ChatInterface from './ChatInterface';
import Sidebar from './Sidebar';
import { useAdminApi } from '../hooks/useAdminApi';

interface MainChatProps {
  isDarkMode: boolean;
  onToggleTheme: () => void;
}

const MainChat: React.FC<MainChatProps> = ({ isDarkMode, onToggleTheme }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [chatKey, setChatKey] = useState(0);
  const [adminEmail, setAdminEmail] = useState<string | null>(null);
  const { isAuthenticated, username, getAdminProfile } = useAdminApi();

  useEffect(() => {
    if (!isAuthenticated) return;
    getAdminProfile().then(p => { if (p) setAdminEmail(p.email ?? null); });
  }, [isAuthenticated, getAdminProfile]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleStartNewChat = () => {
    setChatKey(prev => prev + 1);
    setSidebarOpen(false);
  };

  return (
    <div className="flex h-screen">
      {isAuthenticated && (
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isDarkMode={isDarkMode}
          onToggleTheme={onToggleTheme}
          onStartNewChat={handleStartNewChat}
          adminUsername={username}
          adminEmail={adminEmail}
        />
      )}
      
      <div className="flex-1 flex flex-col">
        <ChatInterface 
          key={chatKey}
          isDarkMode={isDarkMode}
          onToggleTheme={onToggleTheme}
          onToggleSidebar={toggleSidebar}
          isAuthenticated={isAuthenticated}
        />
      </div>
    </div>
  );
};

export default MainChat;